// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import TabmWipContainer from './state-connector';

const TabmWip = props =>
    props.children || <TabmWipContainer {...props}/>;

TabmWip.propTypes = {
    children: PropTypes.node
};

export default TabmWip;



// WEBPACK FOOTER //
// ./src/tabm/wip/index.js